export default "__VITE_ASSET__Blm2k4E7__"